import { render, staticRenderFns } from "./OrderComplete.vue?vue&type=template&id=10f6a56e&scoped=true&"
import script from "./OrderComplete.vue?vue&type=script&lang=ts&"
export * from "./OrderComplete.vue?vue&type=script&lang=ts&"
import style0 from "./OrderComplete.vue?vue&type=style&index=0&id=10f6a56e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f6a56e",
  null
  
)

export default component.exports